import './hiddenhostess/style';
import FormStructure from './hiddenhostess/form_structure';

export default FormStructure;